import {useState} from "react"

export const useRename = () => {
    const [state, setState] = useState(false)

    const start = (name) => {
        setState(name)
    }

    const stop = () => {
        setState(false)
    }

    const isEdit = () => {
        return state !== false
    }

    const getValue = () => {
        return state
    }

    const setValue = (event) => {
        setState(event.target.value)
    }

    return {
        start, stop, isEdit, getValue, setValue,
    }
}